import {CustomStepper} from 'presentation/components/CustomStepper';
import React from 'react';
import {Container} from './styles';
import {useMediaQueries} from 'presentation/pages/private';
import {StepProgressBar} from 'presentation/components';
import {translations} from 'presentation/translations-new';

const {step1, step2} = translations['pt-br'].others.facialBiometric.stepper;

export function Stepper({activeStep}: {activeStep: number}) {
	const {isMobile} = useMediaQueries();

	return (
		<Container>
			{isMobile ? (
				<StepProgressBar currentStep={activeStep + 1} totalSteps={2} />
			) : (
				<CustomStepper stepLabels={[step1, step2]} activeStep={activeStep} />
			)}
		</Container>
	);
}
